export const competitorTypes = {
  ENTITY: "ENTITY",
  PERSON: "PERSON",
};

export const getCompetitorTypeBySport = (sport) => {
  if (sport === "tennis") {
    return competitorTypes.PERSON;
  }
  return competitorTypes.ENTITY;
};
